import { AJAX } from './utilities';

export const LOOKUP_URL_PATH = '/lookup';

export function fetchEmail(uid) {
  return new Promise((resolve) => {
    if (!uid) {
      return resolve();
    }

    const userLookupUrl = `${process.env.TRACKING_BASE_URL}${LOOKUP_URL_PATH}`;

    const urlParams = { uid };
    const headerParams = { username: process.env.TRACKING_API_USERNAME, password: process.env.TRACKING_API_PASSWORD };
    const params = { urlParams, headerParams };

    AJAX(userLookupUrl, params)
      .then(({ email }) => {
        resolve(email || null);
      }).catch(resolve);
  });
}
